<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">บันทึกข้อมูลเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card>
        <v-form ref="add_article" @submit.prevent="create_article">
          <div class="pa-2">
            <div class="mt-4">
              <v-img max-width="400" v-if="imagePreviewURL === null" :lazy-src="img_holder" :src="img_holder" class="preview mx-auto"></v-img>
              <v-img max-width="400" v-if="imagePreviewURL !== null" :lazy-src="img_holder" :src="imagePreviewURL" class="preview mx-auto"></v-img>
            </div>
            <v-file-input color="#86bc3a" accept="image/*" label="เพิ่มรูปหน้าปกบทความ" :rules="[v => !!v || 'กรุณาเพิ่มรูปหน้าปกบทความ']" v-model="article_image" @change="onFileChange"></v-file-input>
            <div class="mt-3 ma-1">
              <v-text-field color="#86bc3a" type="text" label="หัวข้อบทความ" :rules="[v => !!v || 'กรุณากรอกหัวข้อบทความ']" hide-details="auto" v-model="header_content" outlined></v-text-field>
            </div>
            <div class="mt-3 ma-1">
              <div>เนื้อหา</div>
              <quillEditor ref="myQuillEditor" v-model="content"/>
            </div>
            <div class="text-center pt-6 pb-6">
              <v-btn large class="white--text grad-success-bg mobile_btn" style="font-size: 18px" type="submit">บันทึก</v-btn>
            </div>
          </div>
        </v-form>
      </v-card>
    </div>
  </div>
</template>

<script>
import img_holder from "@/assets/picture.png";
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme
import {quillEditor} from 'vue-quill-editor'
import Swal from "sweetalert2";
import {HTTP} from "@/axios";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Article_add",
  components: {
    quillEditor
  },
  data() {
    return {
      loading_page: false,
      img_holder: img_holder,
      imagePreviewURL: null,
      article_image: null,
      header_content: null,
      content: null,
      alert_success: false,
      editorOption: {
        modules: {
          toolbar: ['bold', 'italic', 'underline', 'strike']
        }
      },
    }
  },
  methods: {
    onFileChange(payload) {
      if (payload !== null && payload !== undefined) {
        const file = payload
        let extall ="png,PNG,jpeg,JPEG,jpg,JPG";
        let file_ext = file.name;
        let ext = file_ext.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.imagePreviewURL = null
            this.article_image = null
          })
        } else {
          if (file) {
            this.imagePreviewURL = URL.createObjectURL(file)
            URL.revokeObjectURL(file)
          } else {
            this.imagePreviewURL = null
            this.send_data.addon_file = null
          }
        }
      }else {
        this.imagePreviewURL = null
        this.article_image = null
      }
    },
    create_article() {
      if (this.$refs.add_article.validate()) {
        let extall ="png,PNG,jpeg,JPEG,jpg,JPG";
        let file = this.article_image.name;
        let ext = file.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.imagePreviewURL = null
            this.article_image = null
          })
        }
        else {
          if (this.$refs.add_article.validate()) {
            Swal.fire({
              title: 'คุณต้องการบันทึกข้อมูลหรือไม่ ?',
              icon: 'warning',
              showDenyButton: true,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            }).then((res) => {
              if (res.isConfirmed === true) {
                let config = {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                };
                let formData = new FormData();
                formData.append('article_image', this.article_image, this.article_image.name)
                formData.append('user_id', this.$store.state.userDetail.id)
                formData.append('title', this.header_content)
                formData.append('content', this.content)
                HTTP.post('/manage-website/articles/create', formData, config)
                    .then((res) => {
                      if (res.data.success === true) {
                        Swal.fire({
                          title: 'บันทึกข้อมูลเรียบร้อย !',
                          icon: 'success',
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: `ตกลง`,
                          denyButtonText: `ยกเลิก`,
                        }).then(() => {
                          this.$router.push('/articlemanage')
                        })
                      }
                    })
              }
            })
          }
        }
      }
    }
  },
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
.mobile_btn {
  width: 30%;
}
@media only screen and (max-width: 1180px) {
  .mobile_btn {
    width: 40%;
  }
}
@media only screen and (max-width: 500px) {
  .mobile_btn {
    width: 100%;
  }
}
</style>
